var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-content",style:({ backgroundColor: _vm.isMine ? '#FDE8E8' : '#FFF' })},[_vm._t("default",function(){return _vm._l((_vm.values),function(item,index){return _c('div',{key:index,staticClass:"msg-text",domProps:{"innerHTML":_vm._s(_vm.filterEmotionContent(item.trim()))}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }